import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { handleApiError } from "../../errors";
import { toastService } from "../../screens/notificationPage/ToastContainer";
import {
  getNotificationsStart,
  getNotificationsSuccess,
  getNotificationsFailed,
  markAsReadStart,
  markAsReadSuccess,
  markAsReadFailed,
  markAllAsReadStart,
  markAllAsReadSuccess,
  markAllAsReadFailed,
  deleteNotificationStart,
  deleteNotificationSuccess,
  deleteNotificationFailed,
  clearNotificationsStart,
  clearNotificationsSuccess,
  clearNotificationsFailed,
} from "../notification-slice";
import { API_URL } from "../../constants";
import { APP_CONFIG } from "../../config";

// Get all notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetchAll",
  async (_, { dispatch, getState }) => {
    try {
      dispatch(getNotificationsStart());
      const {
        auth: {
          user: { id: customer_id },
        },
      } = getState();
      console.log("Sending request to /ntf/get with customer_id", customer_id);

      const response = await axios.post(`${APP_CONFIG.API_URL}ntf/get`, {
        customer_id,
      });
      console.log("ress", response);

      dispatch(getNotificationsSuccess(response.data));
      return response.data;
    } catch (error) {
      handleApiError(error, { showToast: true, toastPosition: "top-right" });
      dispatch(getNotificationsFailed(error.message));
      throw error;
    }
  }
);

// Mark notification as read
export const markNotificationAsRead = createAsyncThunk(
  "notifications/markAsRead",
  async (notificationId, { dispatch, getState }) => {
    try {
      dispatch(markAsReadStart({ notificationId }));

      const {
        auth: {
          customer: { id: customer_id },
        },
      } = getState();

      const response = await axios.put(`${APP_CONFIG.API_URL}ntf/mark/read`, {
        id: notificationId,
        customer_id,
      });

      dispatch(markAsReadSuccess({ notificationId }));
      return response.data;
    } catch (error) {
      handleApiError(error, { showToast: true, toastPosition: "top-right" });
      dispatch(markAsReadFailed(error.message));
      throw error;
    }
  }
);

// Mark all as read
export const markAllNotificationsAsRead = createAsyncThunk(
  "notifications/markAllAsRead",
  async (_, { dispatch, getState }) => {
    try {
      dispatch(markAllAsReadStart());

      const {
        auth: {
          user: { id: customer_id },
        },
      } = getState();

      const response = await axios.put(`${APP_CONFIG.API_URL}ntf/read-all`, {
        customer_id,
      });

      dispatch(markAllAsReadSuccess());
      toastService.success("All notifications marked as read");
      return response.data;
    } catch (error) {
      handleApiError(error, { showToast: true, toastPosition: "top-right" });
      dispatch(markAllAsReadFailed(error.message));
      throw error;
    }
  }
);

// Delete a single notification
export const deleteNotification = createAsyncThunk(
  "notifications/delete",
  async (notificationId, { dispatch, getState }) => {
    try {
      dispatch(deleteNotificationStart());

      const {
        auth: {
          user: { id: customer_id },
        },
      } = getState();

      const response = await axios.post(`${APP_CONFIG.API_URL}ntf/delete`, {
        id: notificationId,
        customer_id,
      });

      dispatch(deleteNotificationSuccess({ notificationId }));
      toastService.success("Notification deleted");
      return response.data;
    } catch (error) {
      handleApiError(error, { showToast: true, toastPosition: "top-right" });
      dispatch(deleteNotificationFailed(error.message));
      throw error;
    }
  }
);

// Clear all notifications
export const clearAllNotifications = createAsyncThunk(
  "notifications/clear-all",
  async (_, { dispatch, getState }) => {
    try {
      dispatch(clearNotificationsStart());

      const {
        auth: {
          user: { id: customer_id },
        },
      } = getState();

      const response = await axios.post(`${APP_CONFIG.API_URL}ntf/clear`, {
        customer_id,
      });

      dispatch(clearNotificationsSuccess());
      toastService.success("All notifications cleared");
      return response.data;
    } catch (error) {
      handleApiError(error, { showToast: true, toastPosition: "top-right" });
      dispatch(clearNotificationsFailed(error.message));
      throw error;
    }
  }
);
